// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Input } from '@/components/ui'
import type { OnboardingData } from '@/types'

interface Step2NameProps {
  data:     Partial<OnboardingData>
  onChange: (updates: Partial<OnboardingData>) => void
  errors:   Partial<Record<keyof OnboardingData, string>>
}

export function Step2Name({ data, onChange, errors }: Step2NameProps) {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-ink mb-1">Uw naam</h2>
        <p className="text-sm text-ink-3">
          Uw voornaam gebruiken wij om u aan te spreken. Uw achternaam is optioneel en wordt opgeslagen voor uw dossier.
        </p>
      </div>

      <Input
        label="Voornaam"
        value={data.firstName ?? ''}
        onChange={(e) => onChange({ firstName: e.target.value })}
        error={errors.firstName}
        placeholder="Bijv: Marianne"
        autoComplete="given-name"
        autoFocus
        required
      />

      <Input
        label="Achternaam"
        value={data.lastName ?? ''}
        onChange={(e) => onChange({ lastName: e.target.value })}
        error={errors.lastName}
        placeholder="Bijv: de Vries"
        autoComplete="family-name"
      />

      <p className="text-xs text-ink-4 leading-relaxed bg-sand px-3.5 py-3 rounded-xl">
        Uw naam wordt alleen lokaal opgeslagen op dit apparaat en niet gedeeld met derden.
      </p>
    </div>
  )
}
